import type { Type } from '@angular/core';
import type { IconName } from '@app/components/core/lt-icon/lt-icon.config';

export enum ButtonLayout {
  STACKED = 'stacked',
  INLINE = 'inline'
}

export interface HeaderConfig {
  icon?: IconName;
  theme?: string;
  titleKey?: string;
  titleParams?: Record<string, string>;
  innerTitle?: string;
}

export interface DetailConfig {
  detailsKey?: string;
  innerDetails?: string;
  detailsParams?: Record<string, string>;
  cautionMessageKey?: string;
  innerCautionMessage?: string;
  innerComponent?: Type<unknown>;
  componentInputs?: Record<string, unknown>;
}

export interface ModalResultProvider<T = unknown> {
  getModalResult(): T;
}

export interface ButtonsConfig {
  cancelKey?: string;
  confirmKey?: string;
  layout?: ButtonLayout;
}

export interface ComposableModalConfig {
  header: HeaderConfig;
  detail: DetailConfig;
  buttons: ButtonsConfig;
}

export const DEFAULT_MODAL_CONFIG: ComposableModalConfig = {
  header: {
    icon: undefined,
    titleKey: '',
    innerTitle: ''
  },
  detail: {
    detailsKey: '',
    innerDetails: '',
    detailsParams: {},
    cautionMessageKey: '',
    innerCautionMessage: ''
  },
  buttons: {
    cancelKey: '',
    confirmKey: '',
    layout: ButtonLayout.INLINE
  }
};
